import OrderChangeRequested from '../../../../application/order/events/OrderChangeRequested';
import State from '../../../../application/core/State';
import { getProductCheckLevel } from '../../../Product';
import OrderValidationResult from '../OrderValidationResult';
import { roundValueToMinPackageSize } from '../../../roundValueToPackageSize';
import StockError from '../error';

export default (event: OrderChangeRequested, state: State): OrderValidationResult => {
    const itemStock: number | undefined = getProductCheckLevel(state.products.orderProducts, event.product.articleId, event.sku);
    if (itemStock === undefined || itemStock >= event.value) {
        return {
            value: event.value,
            notification: StockError.Null
        };
    }
    const roundedValue: number = roundValueToMinPackageSize(itemStock!, event.product.packageSize);
    return {
        value: roundedValue,
        notification: StockError.CheckoutValueIsNotAvailable
    };
};



// WEBPACK FOOTER //
// ./src/domain/orders/validators/checkout/checkIfCheckoutOrderIsAvailable.ts